import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import API from '../api'
import FormRadio from 'pobble-components/dist/form-elements/form-radio'
import FaClose from 'react-icons/fa/times-circle'
import FaChevronDown from 'react-icons/fa/chevron-down'
import qs from 'qs'
import { goToLesson } from 'pobble-components/dist/router'

@autobind
class WorkWagollModal extends Component {
  constructor (props) {
    super(props)
    let url = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    let currentLessonId = url && url.lessonId
    this.state = {
      status: '',
      loading: false,
      selectedLesson: currentLessonId ? currentLessonId : '',
      work: this.props.work,
      newLessonTitle: '',
      newLessonOverview: ''
    }
  }

  componentWillMount () {
    this.getLessons()
  }

  getLessons () {
    this.setState({loading: true})
    API.get('/v3/me/presentations?scope=all&include=presentation.names,presentations.limit.100,presentations.page.1,presentations.order.desc').then(resp => this.setState({
      lessons: resp.data.presentations,
      loading: false,
      status: resp.data.presentations.length ? 'existingLesson' : 'newLesson'
    }))
  }

  onLessonSelection (event) {
    this.setState({selectedLesson: event.target.value})
  }

  onStatusSelection (status) {
    this.setState({status})
  }

  handleTitleChange (event) {
    this.setState({ newLessonTitle: event.target.value })
  }

  handleOverviewChange (event) {
    this.setState({ newLessonOverview: event.target.value })
  }

  addToLesson () {
    API.post(`/v3/presentations/${this.state.selectedLesson}/slides`, {
      type: 'Exemplar',
      work_id: this.state.work.id,
      title: this.state.work.title,
      description: this.state.work.description
    })
    .then(() => {
      goToLesson(this.state.selectedLesson, { showLastSlide: true })
    })
  }

  addToNewLesson () {
    this.setState({loading: true})
    API.post(`v3/presentations?include=presentation.names`, {
      title: this.state.newLessonTitle,
      lesson_overview: this.state.newLessonOverview
    })
    .then(resp => {
      this.setState({
        selectedLesson: resp.data.presentation.id,
        lessons: [...this.state.lessons, resp.data.presentation]
      })
      this.addToLesson()
    })
  }

  closeModal () {
    this.props.onCloseModal()
  }

  render () {
    let lessons = this.state.lessons && this.state.lessons.map(lesson => <option key={lesson.id} value={lesson.id}>{lesson.title}</option>)
    return (
      <div className={`resource__modal resource__modal--${this.state.status} resource--modal modal-dialog`}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h4 className='modal-title pull-left'>Select a lesson</h4>
            <span className='modal__close' onClick={this.closeModal}>
              <FaClose />
            </span>
          </div>
          <div className='modal-body'>
            <div className='add-resource__selection'>
              <div className='add-resource__checkbox'>
                <FormRadio
                  name="status"
                  id="existingLesson"
                  onChange={() => this.onStatusSelection('existingLesson')}
                  checked={this.state.status === 'existingLesson'}
                />
              </div>
              <div className='add-resource__content'>
                <label htmlFor='existingLesson'>Open lesson</label>
                {this.state.status === 'existingLesson' && <div className='select'>
                  <select className='select__box' onChange={this.onLessonSelection} value={this.state.selectedLesson}>
                    <option value=''>Select a lesson</option>
                    {lessons}
                  </select>
                  <FaChevronDown className='select__arrow' />
                </div>}
              </div>
            </div>
            <div className='add-resource__selection'>
              <div className='add-resource__checkbox'>
                <FormRadio
                  name="status"
                  id="newLesson"
                  onChange={() => this.onStatusSelection('newLesson')}
                  checked={this.state.status === 'newLesson'}
                />
              </div>
              <div className='add-resource__content'>
                <label htmlFor='newLesson'>New lesson</label>
                {this.state.status === 'newLesson' && <div>
                  <label className='newLesson__label' id='newLessonTitle'>Give your lesson a title <span className={`pull-right ${this.state.newLessonTitle.length > 40 ? 'text-danger' : ''}`}>{(50 - this.state.newLessonTitle.length)}</span></label>
                  <input type='text' id='newLessonTitle' placeholder='Eg. Boudicca!' onChange={this.handleTitleChange} className='form-control' maxLength="50" />
                  <label className='newLesson__label' id='newLessonOverview'>Provide a short overview of this lesson <span className={`pull-right ${this.state.newLessonOverview.length > 190 ? 'text-danger' : ''}`}>{(200 - this.state.newLessonOverview.length)}</span></label>
                  <textarea type='text' className='newLesson__overview' id='newLessonOverview' placeholder="Eg. We are discussing Boudicca's speech and then we are writing our own." onChange={this.handleOverviewChange} className='form-control' maxLength="200" />
                </div>}
              </div>
            </div>
          </div>
          <div className='modal-footer'>
            <div className='btn-toolbar pull-right'>
              <button type='button' className='btn btn-link' onClick={this.closeModal}>Cancel</button>
              {this.state.status === 'newLesson' && <button type='button' className='btn btn-primary' onClick={this.addToNewLesson} disabled={!this.state.newLessonTitle || this.state.newLessonTitle === '' || !this.state.newLessonOverview || this.state.newLessonOverview === ''  || this.state.loading}>Create and go to lesson</button>}
              {this.state.status === 'existingLesson' && <button type='button' className='btn btn-primary metrics__add-exemplar-to-lesson' onClick={this.addToLesson} disabled={!this.state.selectedLesson || this.state.selectedLesson === '' || this.state.loading}>Save and go to lesson</button>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WorkWagollModal

WorkWagollModal.propTypes = {
  id: PropTypes.number,
  work: PropTypes.object,
  lesson: PropTypes.object,
  onCloseModal: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/WorkAddWagollModal.js